/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchConversationOperation,
    BatchConversationOperationFromJSON,
    BatchConversationOperationToJSON,
    CampaignMessageState,
    CampaignMessageStateFromJSON,
    CampaignMessageStateToJSON,
    CampaignMessageStatus,
    CampaignMessageStatusFromJSON,
    CampaignMessageStatusToJSON,
    Conversation,
    ConversationFromJSON,
    ConversationToJSON,
    ConversationBulkParams,
    ConversationBulkParamsFromJSON,
    ConversationBulkParamsToJSON,
    ConversationContext,
    ConversationContextFromJSON,
    ConversationContextToJSON,
    ConversationCreateParams,
    ConversationCreateParamsFromJSON,
    ConversationCreateParamsToJSON,
    ConversationList,
    ConversationListFromJSON,
    ConversationListToJSON,
    ConversationUpdateParams,
    ConversationUpdateParamsFromJSON,
    ConversationUpdateParamsToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    Message,
    MessageFromJSON,
    MessageToJSON,
    MessageCreateParams,
    MessageCreateParamsFromJSON,
    MessageCreateParamsToJSON,
    MessageList,
    MessageListFromJSON,
    MessageListToJSON,
    MessageMedium,
    MessageMediumFromJSON,
    MessageMediumToJSON,
    MessageType,
    MessageTypeFromJSON,
    MessageTypeToJSON,
} from '../models';

export interface ArchiveBulkConversationRequest {
    program_id: string;
    ConversationBulkParams: ConversationBulkParams;
    id?: Array<string>;
    context?: Array<ConversationContext>;
    is_archived?: boolean;
    is_open?: boolean;
    has_sent?: boolean;
    has_recieved?: boolean;
    conversation_id?: string;
    search?: string;
}

export interface ArchiveConversationRequest {
    program_id: string;
    conversation_id: string;
}

export interface CreateConversationRequest {
    program_id: string;
    ConversationCreateParams: ConversationCreateParams;
}

export interface CreateMessageRequest {
    program_id: string;
    MessageCreateParams: MessageCreateParams;
}

export interface FindConversationsRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    id?: Array<string>;
    context?: Array<ConversationContext>;
    is_archived?: boolean;
    is_open?: boolean;
    has_sent?: boolean;
    has_recieved?: boolean;
    conversation_id?: string;
    search?: string;
}

export interface FindMessagesRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    unsubscribed_lt?: Date;
    unsubscribed_gt?: Date;
    unsubscribed_lte?: Date;
    unsubscribed_gte?: Date;
    purchased_lt?: Date;
    purchased_gt?: Date;
    purchased_lte?: Date;
    purchased_gte?: Date;
    product_added_lt?: Date;
    product_added_gt?: Date;
    product_added_lte?: Date;
    product_added_gte?: Date;
    clicked_lt?: Date;
    clicked_gt?: Date;
    clicked_lte?: Date;
    clicked_gte?: Date;
    opened_lt?: Date;
    opened_gt?: Date;
    opened_lte?: Date;
    opened_gte?: Date;
    search?: string;
    conversation_id?: string;
    campaign_id?: string;
    contact_id?: string;
    medium?: Array<MessageMedium>;
    status?: Array<CampaignMessageStatus>;
    state?: Array<CampaignMessageState>;
    type?: Array<MessageType>;
    id?: Array<string>;
}

export interface FindOneConversationRequest {
    program_id: string;
    conversation_id: string;
}

export interface FindOneMessageRequest {
    program_id: string;
    message_id: string;
}

export interface MarkAsClosedConversationRequest {
    program_id: string;
    conversation_id: string;
}

export interface MarkAsOpenConversationRequest {
    program_id: string;
    conversation_id: string;
}

export interface MarkBulkAsClosedConversationRequest {
    program_id: string;
    ConversationBulkParams: ConversationBulkParams;
    id?: Array<string>;
    context?: Array<ConversationContext>;
    is_archived?: boolean;
    is_open?: boolean;
    has_sent?: boolean;
    has_recieved?: boolean;
    conversation_id?: string;
    search?: string;
}

export interface MarkBulkAsOpenConversationRequest {
    program_id: string;
    ConversationBulkParams: ConversationBulkParams;
    id?: Array<string>;
    context?: Array<ConversationContext>;
    is_archived?: boolean;
    is_open?: boolean;
    has_sent?: boolean;
    has_recieved?: boolean;
    conversation_id?: string;
    search?: string;
}

export interface SendMessageRequest {
    program_id: string;
    message_id: string;
}

export interface TrackMessageRequest {
    program_id: string;
    message_id: string;
}

export interface UnarchiveBulkConversationRequest {
    program_id: string;
    ConversationBulkParams: ConversationBulkParams;
    id?: Array<string>;
    context?: Array<ConversationContext>;
    is_archived?: boolean;
    is_open?: boolean;
    has_sent?: boolean;
    has_recieved?: boolean;
    conversation_id?: string;
    search?: string;
}

export interface UnarchiveConversationRequest {
    program_id: string;
    conversation_id: string;
}

export interface UpdateConversationRequest {
    program_id: string;
    conversation_id: string;
    ConversationUpdateParams: ConversationUpdateParams;
}

/**
 * 
 */
export class MessagesApi extends runtime.BaseAPI {

    /**
     * Archive conversations in bulk
     */
    async archiveBulkConversationRaw(requestParameters: ArchiveBulkConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchConversationOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling archiveBulkConversation.');
        }

        if (requestParameters.ConversationBulkParams === null || requestParameters.ConversationBulkParams === undefined) {
            throw new runtime.RequiredError('ConversationBulkParams','Required parameter requestParameters.ConversationBulkParams was null or undefined when calling archiveBulkConversation.');
        }

        const queryParameters: any = {};

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.context) {
            queryParameters['context'] = requestParameters.context;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        if (requestParameters.is_open !== undefined) {
            queryParameters['is_open'] = requestParameters.is_open;
        }

        if (requestParameters.has_sent !== undefined) {
            queryParameters['has_sent'] = requestParameters.has_sent;
        }

        if (requestParameters.has_recieved !== undefined) {
            queryParameters['has_recieved'] = requestParameters.has_recieved;
        }

        if (requestParameters.conversation_id !== undefined) {
            queryParameters['conversation_id'] = requestParameters.conversation_id;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/conversations/archive`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConversationBulkParamsToJSON(requestParameters.ConversationBulkParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchConversationOperationFromJSON(jsonValue));
    }

    /**
     * Archive conversations in bulk
     */
    async archiveBulkConversation(requestParameters: ArchiveBulkConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchConversationOperation> {
        const response = await this.archiveBulkConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Archive conversation
     */
    async archiveConversationRaw(requestParameters: ArchiveConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Conversation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling archiveConversation.');
        }

        if (requestParameters.conversation_id === null || requestParameters.conversation_id === undefined) {
            throw new runtime.RequiredError('conversation_id','Required parameter requestParameters.conversation_id was null or undefined when calling archiveConversation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/conversations/{conversation_id}/archive`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters.conversation_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConversationFromJSON(jsonValue));
    }

    /**
     * Archive conversation
     */
    async archiveConversation(requestParameters: ArchiveConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Conversation> {
        const response = await this.archiveConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create conversation
     */
    async createConversationRaw(requestParameters: CreateConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Conversation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createConversation.');
        }

        if (requestParameters.ConversationCreateParams === null || requestParameters.ConversationCreateParams === undefined) {
            throw new runtime.RequiredError('ConversationCreateParams','Required parameter requestParameters.ConversationCreateParams was null or undefined when calling createConversation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/conversations`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConversationCreateParamsToJSON(requestParameters.ConversationCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConversationFromJSON(jsonValue));
    }

    /**
     * Create conversation
     */
    async createConversation(requestParameters: CreateConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Conversation> {
        const response = await this.createConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create message
     */
    async createMessageRaw(requestParameters: CreateMessageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Message>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createMessage.');
        }

        if (requestParameters.MessageCreateParams === null || requestParameters.MessageCreateParams === undefined) {
            throw new runtime.RequiredError('MessageCreateParams','Required parameter requestParameters.MessageCreateParams was null or undefined when calling createMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/messages`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MessageCreateParamsToJSON(requestParameters.MessageCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * Create message
     */
    async createMessage(requestParameters: CreateMessageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Message> {
        const response = await this.createMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all conversations
     */
    async findConversationsRaw(requestParameters: FindConversationsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ConversationList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findConversations.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.context) {
            queryParameters['context'] = requestParameters.context;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        if (requestParameters.is_open !== undefined) {
            queryParameters['is_open'] = requestParameters.is_open;
        }

        if (requestParameters.has_sent !== undefined) {
            queryParameters['has_sent'] = requestParameters.has_sent;
        }

        if (requestParameters.has_recieved !== undefined) {
            queryParameters['has_recieved'] = requestParameters.has_recieved;
        }

        if (requestParameters.conversation_id !== undefined) {
            queryParameters['conversation_id'] = requestParameters.conversation_id;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/conversations`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConversationListFromJSON(jsonValue));
    }

    /**
     * List all conversations
     */
    async findConversations(requestParameters: FindConversationsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ConversationList> {
        const response = await this.findConversationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all messages
     */
    async findMessagesRaw(requestParameters: FindMessagesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<MessageList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findMessages.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.unsubscribed_lt !== undefined) {
            queryParameters['unsubscribed_lt'] = (requestParameters.unsubscribed_lt as any).toISOString();
        }

        if (requestParameters.unsubscribed_gt !== undefined) {
            queryParameters['unsubscribed_gt'] = (requestParameters.unsubscribed_gt as any).toISOString();
        }

        if (requestParameters.unsubscribed_lte !== undefined) {
            queryParameters['unsubscribed_lte'] = (requestParameters.unsubscribed_lte as any).toISOString();
        }

        if (requestParameters.unsubscribed_gte !== undefined) {
            queryParameters['unsubscribed_gte'] = (requestParameters.unsubscribed_gte as any).toISOString();
        }

        if (requestParameters.purchased_lt !== undefined) {
            queryParameters['purchased_lt'] = (requestParameters.purchased_lt as any).toISOString();
        }

        if (requestParameters.purchased_gt !== undefined) {
            queryParameters['purchased_gt'] = (requestParameters.purchased_gt as any).toISOString();
        }

        if (requestParameters.purchased_lte !== undefined) {
            queryParameters['purchased_lte'] = (requestParameters.purchased_lte as any).toISOString();
        }

        if (requestParameters.purchased_gte !== undefined) {
            queryParameters['purchased_gte'] = (requestParameters.purchased_gte as any).toISOString();
        }

        if (requestParameters.product_added_lt !== undefined) {
            queryParameters['product_added_lt'] = (requestParameters.product_added_lt as any).toISOString();
        }

        if (requestParameters.product_added_gt !== undefined) {
            queryParameters['product_added_gt'] = (requestParameters.product_added_gt as any).toISOString();
        }

        if (requestParameters.product_added_lte !== undefined) {
            queryParameters['product_added_lte'] = (requestParameters.product_added_lte as any).toISOString();
        }

        if (requestParameters.product_added_gte !== undefined) {
            queryParameters['product_added_gte'] = (requestParameters.product_added_gte as any).toISOString();
        }

        if (requestParameters.clicked_lt !== undefined) {
            queryParameters['clicked_lt'] = (requestParameters.clicked_lt as any).toISOString();
        }

        if (requestParameters.clicked_gt !== undefined) {
            queryParameters['clicked_gt'] = (requestParameters.clicked_gt as any).toISOString();
        }

        if (requestParameters.clicked_lte !== undefined) {
            queryParameters['clicked_lte'] = (requestParameters.clicked_lte as any).toISOString();
        }

        if (requestParameters.clicked_gte !== undefined) {
            queryParameters['clicked_gte'] = (requestParameters.clicked_gte as any).toISOString();
        }

        if (requestParameters.opened_lt !== undefined) {
            queryParameters['opened_lt'] = (requestParameters.opened_lt as any).toISOString();
        }

        if (requestParameters.opened_gt !== undefined) {
            queryParameters['opened_gt'] = (requestParameters.opened_gt as any).toISOString();
        }

        if (requestParameters.opened_lte !== undefined) {
            queryParameters['opened_lte'] = (requestParameters.opened_lte as any).toISOString();
        }

        if (requestParameters.opened_gte !== undefined) {
            queryParameters['opened_gte'] = (requestParameters.opened_gte as any).toISOString();
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.conversation_id !== undefined) {
            queryParameters['conversation_id'] = requestParameters.conversation_id;
        }

        if (requestParameters.campaign_id !== undefined) {
            queryParameters['campaign_id'] = requestParameters.campaign_id;
        }

        if (requestParameters.contact_id !== undefined) {
            queryParameters['contact_id'] = requestParameters.contact_id;
        }

        if (requestParameters.medium) {
            queryParameters['medium'] = requestParameters.medium;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.state) {
            queryParameters['state'] = requestParameters.state;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/messages`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageListFromJSON(jsonValue));
    }

    /**
     * List all messages
     */
    async findMessages(requestParameters: FindMessagesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<MessageList> {
        const response = await this.findMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find conversation by id
     */
    async findOneConversationRaw(requestParameters: FindOneConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Conversation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneConversation.');
        }

        if (requestParameters.conversation_id === null || requestParameters.conversation_id === undefined) {
            throw new runtime.RequiredError('conversation_id','Required parameter requestParameters.conversation_id was null or undefined when calling findOneConversation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/conversations/{conversation_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters.conversation_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConversationFromJSON(jsonValue));
    }

    /**
     * Find conversation by id
     */
    async findOneConversation(requestParameters: FindOneConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Conversation> {
        const response = await this.findOneConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find message by id
     */
    async findOneMessageRaw(requestParameters: FindOneMessageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Message>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneMessage.');
        }

        if (requestParameters.message_id === null || requestParameters.message_id === undefined) {
            throw new runtime.RequiredError('message_id','Required parameter requestParameters.message_id was null or undefined when calling findOneMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/messages/{message_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"message_id"}}`, encodeURIComponent(String(requestParameters.message_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * Find message by id
     */
    async findOneMessage(requestParameters: FindOneMessageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Message> {
        const response = await this.findOneMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark conversation as closed
     */
    async markAsClosedConversationRaw(requestParameters: MarkAsClosedConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Conversation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling markAsClosedConversation.');
        }

        if (requestParameters.conversation_id === null || requestParameters.conversation_id === undefined) {
            throw new runtime.RequiredError('conversation_id','Required parameter requestParameters.conversation_id was null or undefined when calling markAsClosedConversation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/conversations/{conversation_id}/close`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters.conversation_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConversationFromJSON(jsonValue));
    }

    /**
     * Mark conversation as closed
     */
    async markAsClosedConversation(requestParameters: MarkAsClosedConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Conversation> {
        const response = await this.markAsClosedConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark conversation as open
     */
    async markAsOpenConversationRaw(requestParameters: MarkAsOpenConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Conversation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling markAsOpenConversation.');
        }

        if (requestParameters.conversation_id === null || requestParameters.conversation_id === undefined) {
            throw new runtime.RequiredError('conversation_id','Required parameter requestParameters.conversation_id was null or undefined when calling markAsOpenConversation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/conversations/{conversation_id}/open`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters.conversation_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConversationFromJSON(jsonValue));
    }

    /**
     * Mark conversation as open
     */
    async markAsOpenConversation(requestParameters: MarkAsOpenConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Conversation> {
        const response = await this.markAsOpenConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark conversations closed in bulk
     */
    async markBulkAsClosedConversationRaw(requestParameters: MarkBulkAsClosedConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchConversationOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling markBulkAsClosedConversation.');
        }

        if (requestParameters.ConversationBulkParams === null || requestParameters.ConversationBulkParams === undefined) {
            throw new runtime.RequiredError('ConversationBulkParams','Required parameter requestParameters.ConversationBulkParams was null or undefined when calling markBulkAsClosedConversation.');
        }

        const queryParameters: any = {};

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.context) {
            queryParameters['context'] = requestParameters.context;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        if (requestParameters.is_open !== undefined) {
            queryParameters['is_open'] = requestParameters.is_open;
        }

        if (requestParameters.has_sent !== undefined) {
            queryParameters['has_sent'] = requestParameters.has_sent;
        }

        if (requestParameters.has_recieved !== undefined) {
            queryParameters['has_recieved'] = requestParameters.has_recieved;
        }

        if (requestParameters.conversation_id !== undefined) {
            queryParameters['conversation_id'] = requestParameters.conversation_id;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/conversations/close`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConversationBulkParamsToJSON(requestParameters.ConversationBulkParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchConversationOperationFromJSON(jsonValue));
    }

    /**
     * Mark conversations closed in bulk
     */
    async markBulkAsClosedConversation(requestParameters: MarkBulkAsClosedConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchConversationOperation> {
        const response = await this.markBulkAsClosedConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark conversations open in bulk
     */
    async markBulkAsOpenConversationRaw(requestParameters: MarkBulkAsOpenConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchConversationOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling markBulkAsOpenConversation.');
        }

        if (requestParameters.ConversationBulkParams === null || requestParameters.ConversationBulkParams === undefined) {
            throw new runtime.RequiredError('ConversationBulkParams','Required parameter requestParameters.ConversationBulkParams was null or undefined when calling markBulkAsOpenConversation.');
        }

        const queryParameters: any = {};

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.context) {
            queryParameters['context'] = requestParameters.context;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        if (requestParameters.is_open !== undefined) {
            queryParameters['is_open'] = requestParameters.is_open;
        }

        if (requestParameters.has_sent !== undefined) {
            queryParameters['has_sent'] = requestParameters.has_sent;
        }

        if (requestParameters.has_recieved !== undefined) {
            queryParameters['has_recieved'] = requestParameters.has_recieved;
        }

        if (requestParameters.conversation_id !== undefined) {
            queryParameters['conversation_id'] = requestParameters.conversation_id;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/conversations/open`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConversationBulkParamsToJSON(requestParameters.ConversationBulkParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchConversationOperationFromJSON(jsonValue));
    }

    /**
     * Mark conversations open in bulk
     */
    async markBulkAsOpenConversation(requestParameters: MarkBulkAsOpenConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchConversationOperation> {
        const response = await this.markBulkAsOpenConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send message
     */
    async sendMessageRaw(requestParameters: SendMessageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Message>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling sendMessage.');
        }

        if (requestParameters.message_id === null || requestParameters.message_id === undefined) {
            throw new runtime.RequiredError('message_id','Required parameter requestParameters.message_id was null or undefined when calling sendMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/messages/{message_id}/send`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"message_id"}}`, encodeURIComponent(String(requestParameters.message_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * Send message
     */
    async sendMessage(requestParameters: SendMessageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Message> {
        const response = await this.sendMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Track view message
     */
    async trackMessageRaw(requestParameters: TrackMessageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Message>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling trackMessage.');
        }

        if (requestParameters.message_id === null || requestParameters.message_id === undefined) {
            throw new runtime.RequiredError('message_id','Required parameter requestParameters.message_id was null or undefined when calling trackMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/messages/{message_id}/track`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"message_id"}}`, encodeURIComponent(String(requestParameters.message_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * Track view message
     */
    async trackMessage(requestParameters: TrackMessageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Message> {
        const response = await this.trackMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unarchive conversations in bulk
     */
    async unarchiveBulkConversationRaw(requestParameters: UnarchiveBulkConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchConversationOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling unarchiveBulkConversation.');
        }

        if (requestParameters.ConversationBulkParams === null || requestParameters.ConversationBulkParams === undefined) {
            throw new runtime.RequiredError('ConversationBulkParams','Required parameter requestParameters.ConversationBulkParams was null or undefined when calling unarchiveBulkConversation.');
        }

        const queryParameters: any = {};

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.context) {
            queryParameters['context'] = requestParameters.context;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        if (requestParameters.is_open !== undefined) {
            queryParameters['is_open'] = requestParameters.is_open;
        }

        if (requestParameters.has_sent !== undefined) {
            queryParameters['has_sent'] = requestParameters.has_sent;
        }

        if (requestParameters.has_recieved !== undefined) {
            queryParameters['has_recieved'] = requestParameters.has_recieved;
        }

        if (requestParameters.conversation_id !== undefined) {
            queryParameters['conversation_id'] = requestParameters.conversation_id;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/conversations/unarchive`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConversationBulkParamsToJSON(requestParameters.ConversationBulkParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchConversationOperationFromJSON(jsonValue));
    }

    /**
     * Unarchive conversations in bulk
     */
    async unarchiveBulkConversation(requestParameters: UnarchiveBulkConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchConversationOperation> {
        const response = await this.unarchiveBulkConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unarchive conversation
     */
    async unarchiveConversationRaw(requestParameters: UnarchiveConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Conversation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling unarchiveConversation.');
        }

        if (requestParameters.conversation_id === null || requestParameters.conversation_id === undefined) {
            throw new runtime.RequiredError('conversation_id','Required parameter requestParameters.conversation_id was null or undefined when calling unarchiveConversation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/conversations/{conversation_id}/unarchive`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters.conversation_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConversationFromJSON(jsonValue));
    }

    /**
     * Unarchive conversation
     */
    async unarchiveConversation(requestParameters: UnarchiveConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Conversation> {
        const response = await this.unarchiveConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Conversation
     */
    async updateConversationRaw(requestParameters: UpdateConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Conversation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateConversation.');
        }

        if (requestParameters.conversation_id === null || requestParameters.conversation_id === undefined) {
            throw new runtime.RequiredError('conversation_id','Required parameter requestParameters.conversation_id was null or undefined when calling updateConversation.');
        }

        if (requestParameters.ConversationUpdateParams === null || requestParameters.ConversationUpdateParams === undefined) {
            throw new runtime.RequiredError('ConversationUpdateParams','Required parameter requestParameters.ConversationUpdateParams was null or undefined when calling updateConversation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/conversations/{conversation_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters.conversation_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ConversationUpdateParamsToJSON(requestParameters.ConversationUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConversationFromJSON(jsonValue));
    }

    /**
     * Update Conversation
     */
    async updateConversation(requestParameters: UpdateConversationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Conversation> {
        const response = await this.updateConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
